// Điểm mở rộng của module Hoa hồng & thu nhập (FSD.md §2.1, §3.10): không có Tạo mới / Tìm nhanh; lớp phủ phiếu thu nhập;
// thời gian thực.
import { qk, type RealtimeBinding } from '@/shared/api';
import { lazyComponent, type OverlayDef } from '@/shared/lib';
import type { CreateItem } from '@/widgets/app-shell';

/** Thành phần lớp phủ nạp khi mở (chunk riêng; OverlayHost nạp trước lúc rảnh). */
const PayslipOverlay = lazyComponent(() => import('./ui/overlays'), (x) => x.PayslipOverlay, 'PayslipOverlay');

/** Không có mục "Tạo mới" (kỳ chi trả chốt tại tab Kỳ chi trả; hoa hồng sinh từ giao dịch). */
export const createItems: CreateItem[] = [];

/** ?payslip=YYYY-MM:staffId — phiếu thu nhập, mở từ mọi trang khi module Hoa hồng hiển thị. */
export const overlays: OverlayDef[] = [{ key: 'payslip', module: 'commission', layer: 'modal', component: PayslipOverlay }];

/**
 * - `commission.payouts` (commission-service: chốt / tính lại / duyệt / saga / đã chi / tất toán chuyển trừ) ⇒ mọi khoá
 *   'commission' + Tổng quan.
 * - `commission.ledger` (sổ hoa hồng tính lại theo giao dịch) ⇒ 'commission' + khối hoa hồng trong drawer giao dịch + Tổng
 *   quan / Quy trình.
 * - `deals` (thao tác giao dịch) ⇒ 'commission' gộp 1,5 s (projection bất đồng bộ — FSD §3.10).
 */
export const realtime: RealtimeBinding[] = [
  { topic: 'commission.payouts', module: 'commission', keys: () => [qk.commission.all, qk.dashboard.all] },
  { topic: 'commission.ledger', module: 'commission', keys: () => [qk.commission.all, [...qk.deals.all, 'commission'], qk.dashboard.all, qk.process.summary()], throttleMs: 500 },
  { topic: 'deals', module: 'commission', keys: () => [qk.commission.all], throttleMs: 1500 },
];
